export default __webpack_public_path__ + "static/media/default-thumbnail.9f7e6bc8.svg";